module.exports = __webpack_public_path__ + "static/media/bio-5@2x.b0f8c8ff.jpg";